<div class="layout__inner-card w-full">
  <h3 class="text-primary mb-0"
    >{{ title }}
    @if (tooltipText) {
      <span
        [pTooltip]="tooltipText"
        tooltipPosition="top"
        hideDelay="1000"
        class="text-sm pi pi-info-circle pb-1"></span>
    }
  </h3>
  @if (subtitle) {
    <p>{{ subtitle }}</p>
  }

  <ng-content></ng-content>

  @if (note) {
    <p class="text-sm mt-3">{{ note }}</p>
  }
</div>
